import { HTTP_STATUS_OK } from '../../smartpak/httpstatus';
import customerData from './customerProfileData';
import customerProfileAPI from '../myaccount/api/customerprofile';

const customerProfile = {
    init: function(ids) {
        this._getCustomerProfileQuestions(ids);
    },
    _getCustomerProfileQuestions: function(ids) {
        customerProfileAPI.getCustomerProfileInfo().done(function(data) {
            if (data.Status === HTTP_STATUS_OK) {
                customerData.init(data, ids);
            }
        });
    },
    _saveCustomerProfileQuestions: function(data) {
        customerProfileAPI.saveCustomerProfileInfo(data).done(function(result) {
            if (result.Status === HTTP_STATUS_OK) {
                window.location.reload();
            }
        });
    }
};

export default customerProfile;